import React from 'react';
import PropTypes from 'prop-types';
import withCookieConsentSoundCloud from './withCookieConsentSoundCloud';
import FormattedText from '../../../01_atoms/FormattedText';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

const Content = withCookieConsentSoundCloud(({ html }) => <FormattedText text={html} />);

Content.propTypes = {
  html: PropTypes.string.isRequired,
};

const BBSoundCloud = ({ behaviorSettings = null, uuid = null, ...props }) => (
  <div
    className={`bb bb-soundcloud ${styles['bb-soundcloud']} ${generateClassNameByBehaviorSettings(
      behaviorSettings,
    )}`}
    id={uuid}
  >
    <div className="container">
      <Content {...props} />
    </div>
  </div>
);

BBSoundCloud.propTypes = {
  html: PropTypes.string.isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBSoundCloud;
